import {
  IStation,
  RestrictionStatus,
} from 'dataSources/Typicode/stations/types';
import { TIsLoading } from 'common/types/common';
import { StatusLoading } from 'common/constants/statusLoading';

import { IStationFilter } from './stationFilter';
import { IStationMap } from './stationMap';
import { IFitBounds } from 'common/types/map/fitBounds';
import {
  AvailabilityType,
  FuelType,
} from 'pages/Map/components/FuelAvailabilityButton/constants';

export const STATE = 'STATIONS';
export interface IState {
  filter: {
    statusLoading?: StatusLoading;
    data: IStationFilter;
  };
  routeFilter: {
    data: IStationFilter;
  };
  stations: {
    isLoading: TIsLoading;
    fitBounds: IFitBounds;
    data: IStation[];
  };
  actionStations: {
    isLoading: TIsLoading;
    fitBounds: IFitBounds;
    data: IStation[];
  };
  allStations: {
    isLoading: TIsLoading;
    data: IStation[];
    dataMap: IStationMap;
  };
  restrictions: {
    serviceNtType: FuelType | string;
    mode: AvailabilityType;
    statuses: Array<RestrictionStatus>;
  };
}
